import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  Card,
  Button,
  Paragraph,
  SmallText,
  Row,
  Col,
  TextArea
} from '../../../legacy/hui/src/styled/';
import feedbackTickIcon from '../../images/feedback-tick-icon.svg';
import questionIcon from '../../images/question-icon.svg';
import likeIcon from '../../images/like-icon.svg';
import Loader from '../Loader';
import { ButtonSubmit } from '../Bunnings/Buttons';

export const TitleCard = Card.Section.extend`
  display: flex;
  align-items: center; 
  position: relative
`;

export const ButtonBunnings = Button.extend`
  font-size: 12px;
  width: 100%;
  padding: 8px 0;
  color: #136067;
  border-color: #136067;

  &.no,
  &.yes {
    background-color: #136067;
    color: #fff;
  }
`;

const Error = styled(SmallText)`
  color: ${props => props.theme.danger};
`;

const FeedbackTickIcon = styled.img`
  @media (min-width: ${props => props.theme.breakpoints.sm}rem) {
    padding-right: 1.2rem;
    flex-shrink: 0;
  }
`;

const Tips = styled.div`
  span {
    display: inline-block;
    text-decoration: underline;
    cursor: pointer;
    font-size: 14px;
  }
  img {
    margin-right: 8px;
    position: relative;
    top: 4px;
  }
  p {
    margin-top: 10px;
    color: ${props => props.theme.muted};
  }
  color: ${props => props.theme.secondary};
`;

const CardFeeback = Card.extend`
  margin-top: 16px !important;
`;

export class FeedbackCard extends React.Component {
  static propTypes = {
    feedback: PropTypes.object,
    tradieType: PropTypes.string,
    jobAssignmentId: PropTypes.number,
    completedByConsumer: PropTypes.number,
    submitFeedback: PropTypes.func
  };

  state = {
    submitStep: 'pending', // 'yes' or 'no',
    feedbackValue: '',
    tipsExpand: false
  };

  toggleTips = () => {
    this.setState(prev => {
      return { tipsExpand: prev.tipsExpand === true ? false : true };
    });
  };

  collapseTips = () => {
    this.setState({
      tipsExpand: false
    });
  };

  onNoClick = () => {
    this.setState({
      submitStep: 'no'
    });
  };

  onYesClick = () => {
    this.setState({
      submitStep: 'yes'
    });
  };

  onFeedbackChange = e => {
    this.setState({
      feedbackValue: e.target.value
    });
  };

  onSubmitClick = () => {
    const { submitFeedback, jobAssignmentId } = this.props;
    const { feedbackValue, submitStep } = this.state;

    if (submitStep === 'pending') {
      alert('Please tell us whether the job has been completed to your satisfaction');
      return;
    }

    submitFeedback(feedbackValue, submitStep === 'yes', jobAssignmentId);
  };

  render() {
    const { tradieType, feedback, completedByConsumer, ...rest } = this.props;
    const { tipsExpand, submitStep, feedbackValue } = this.state;
    const { sending, success, errorMessage } = feedback;

    return (
      <CardFeeback snow p={0} {...rest}>
        <TitleCard secondary p={1} pr={2}>
          <FeedbackTickIcon src={feedbackTickIcon} />
          {completedByConsumer === 1 || (success && submitStep === 'yes')
            ? 'Job Complete'
            : `Your ${tradieType} has marked your job as complete`}
        </TitleCard>
        {completedByConsumer === 1 || (success && submitStep === 'yes') ? (
          <Card.Section p={1.5} style={{ boxShadow: 'none' }}>
            <Row>
              <Col xs={1.5} pt={0.5}>
                <img src={likeIcon} />
              </Col>
              <Col xs={10.5}>
                <SmallText mb={0}>Thank you for using the Bunnings Installation Service.</SmallText>
              </Col>
            </Row>
          </Card.Section>
        ) : (
          <div>
            <Card.Section
              p={0.5}
              pl={{ xs: 1.5, sm: 3.6 }}
              pr={{ xs: 1.5, sm: 3.6 }}
              style={{ boxShadow: 'none' }}
            >
              {completedByConsumer !== 2 && !success && (
                <div>
                  <SmallText m="0.5rem 0 1rem">
                    Has the job been completed to your satisfaction?
                  </SmallText>
                  <Row>
                    <Col xs={6}>
                      <ButtonBunnings
                        className={submitStep === 'yes' ? 'yes' : ''}
                        secondary
                        small
                        ghost
                        style={{ width: '100%' }}
                        onClick={this.onYesClick}
                      >
                        Yes thanks
                      </ButtonBunnings>
                    </Col>
                    <Col xs={6}>
                      <ButtonBunnings
                        className={submitStep === 'no' ? 'no' : ''}
                        secondary
                        small
                        ghost
                        style={{ width: '100%' }}
                        onClick={this.onNoClick}
                      >
                        No
                      </ButtonBunnings>
                    </Col>
                  </Row>
                </div>
              )}
              {(completedByConsumer === 2 || (success && submitStep === 'no')) && (
                <div>
                  <SmallText mt={1.5}>We&apos;re sorry to hear you&apos;re not happy.</SmallText>
                  <SmallText>
                    A member of the hipages support team will contact you shortly to discuss your
                    job.
                  </SmallText>
                  <SmallText>If you want to talk to someone now.</SmallText>
                  <Paragraph mb={0.2} style={{ color: '#136067', fontSize: '20px' }}>
                    Phone 1300 043 520
                  </Paragraph>
                </div>
              )}
            </Card.Section>
            {(submitStep === 'yes' || submitStep === 'no') && !success && (
              <Card.Section p={1.5} pt={0.5} style={{ boxShadow: 'none' }}>
                {errorMessage.length > 0 && <Error> {errorMessage}</Error>}
                <SmallText>Tell us more</SmallText>
                <TextArea
                  disabled={sending}
                  style={{ borderColor: '#B4B4B5', height: '100px', fontSize: '14px' }}
                  placeholder="Enter a short message"
                  onChange={this.onFeedbackChange}
                  value={feedbackValue}
                />
                <ButtonSubmit mt={1} onClick={this.onSubmitClick}>
                  {sending ? <Loader /> : 'Submit'}
                </ButtonSubmit>
              </Card.Section>
            )}

            <Card.Section p={1.5} pt={0.5} style={{ boxShadow: 'none' }}>
              <Tips>
                <div onClick={this.toggleTips}>
                  <img src={questionIcon} />
                  <span>Why am I seeing this?</span>
                </div>
                {tipsExpand && (
                  <div>
                    <SmallText>
                      Your {tradieType} has told us that they&apos;ve finished your job and
                      you&apos;re satisfied. We&apos;re making sure that you agree
                    </SmallText>
                    <div onClick={this.collapseTips}>
                      <span>view less..</span>
                    </div>
                  </div>
                )}
              </Tips>
            </Card.Section>
          </div>
        )}
      </CardFeeback>
    );
  }
}
